/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { Accommodation } from '../models/accommodation';
import { AccommodationPartial } from '../models/accommodation-partial';
import { AccommodationWithRelations } from '../models/accommodation-with-relations';
import { Client } from '../models/client';
import { ClientPartial } from '../models/client-partial';
import { ClientWithRelations } from '../models/client-with-relations';
import { Count } from '../models/count';
import { DailyProgramItem } from '../models/daily-program-item';
import { DailyProgramItemPartial } from '../models/daily-program-item-partial';
import { DailyProgramItemWithRelations } from '../models/daily-program-item-with-relations';
import { NewTour } from '../models/new-tour';
import { Tour } from '../models/tour';
import { TourPartial } from '../models/tour-partial';
import { TourWithRelations } from '../models/tour-with-relations';

@Injectable({
  providedIn: 'root',
})
export class TourControllerService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation tourControllerCount
   */
  static readonly TourControllerCountPath = '/tours/count';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `count()` instead.
   *
   * This method doesn't expect any request body.
   */
  count$Response(params?: {
    where?: any;
  }): Observable<StrictHttpResponse<Count>> {

    const rb = new RequestBuilder(this.rootUrl, TourControllerService.TourControllerCountPath, 'get');
    if (params) {
      rb.query('where', params.where, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Count>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `count$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  count(params?: {
    where?: any;
  }): Observable<Count> {

    return this.count$Response(params).pipe(
      map((r: StrictHttpResponse<Count>) => r.body as Count)
    );
  }

  /**
   * Path part for operation tourControllerFindAccommodations
   */
  static readonly TourControllerFindAccommodationsPath = '/tours/{id}/accommodation';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `findAccommodations()` instead.
   *
   * This method doesn't expect any request body.
   */
  findAccommodations$Response(params: {
    id: string;
    filter?: any;
  }): Observable<StrictHttpResponse<Array<AccommodationWithRelations>>> {

    const rb = new RequestBuilder(this.rootUrl, TourControllerService.TourControllerFindAccommodationsPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
      rb.query('filter', params.filter, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<AccommodationWithRelations>>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `findAccommodations$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  findAccommodations(params: {
    id: string;
    filter?: any;
  }): Observable<Array<AccommodationWithRelations>> {

    return this.findAccommodations$Response(params).pipe(
      map((r: StrictHttpResponse<Array<AccommodationWithRelations>>) => r.body as Array<AccommodationWithRelations>)
    );
  }

  /**
   * Path part for operation tourControllerCreateAccommodation
   */
  static readonly TourControllerCreateAccommodationPath = '/tours/{id}/accommodation';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createAccommodation()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createAccommodation$Response(params: {
    id: string;
    body?: Accommodation
  }): Observable<StrictHttpResponse<Accommodation>> {

    const rb = new RequestBuilder(this.rootUrl, TourControllerService.TourControllerCreateAccommodationPath, 'post');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Accommodation>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `createAccommodation$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createAccommodation(params: {
    id: string;
    body?: Accommodation
  }): Observable<Accommodation> {

    return this.createAccommodation$Response(params).pipe(
      map((r: StrictHttpResponse<Accommodation>) => r.body as Accommodation)
    );
  }

  /**
   * Path part for operation tourControllerDeleteAccommodation
   */
  static readonly TourControllerDeleteAccommodationPath = '/tours/{id}/accommodation';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteAccommodation()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteAccommodation$Response(params: {
    id: string;
    where?: any;
  }): Observable<StrictHttpResponse<Count>> {

    const rb = new RequestBuilder(this.rootUrl, TourControllerService.TourControllerDeleteAccommodationPath, 'delete');
    if (params) {
      rb.path('id', params.id, {});
      rb.query('where', params.where, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Count>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `deleteAccommodation$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteAccommodation(params: {
    id: string;
    where?: any;
  }): Observable<Count> {

    return this.deleteAccommodation$Response(params).pipe(
      map((r: StrictHttpResponse<Count>) => r.body as Count)
    );
  }

  /**
   * Path part for operation tourControllerPatchAccommodation
   */
  static readonly TourControllerPatchAccommodationPath = '/tours/{id}/accommodation';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `patchAccommodation()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  patchAccommodation$Response(params: {
    id: string;
    where?: any;
    body?: AccommodationPartial
  }): Observable<StrictHttpResponse<Count>> {

    const rb = new RequestBuilder(this.rootUrl, TourControllerService.TourControllerPatchAccommodationPath, 'patch');
    if (params) {
      rb.path('id', params.id, {});
      rb.query('where', params.where, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Count>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `patchAccommodation$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  patchAccommodation(params: {
    id: string;
    where?: any;
    body?: AccommodationPartial
  }): Observable<Count> {

    return this.patchAccommodation$Response(params).pipe(
      map((r: StrictHttpResponse<Count>) => r.body as Count)
    );
  }

  /**
   * Path part for operation tourControllerFindClients
   */
  static readonly TourControllerFindClientsPath = '/tours/{id}/client';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `findClients()` instead.
   *
   * This method doesn't expect any request body.
   */
  findClients$Response(params: {
    id: string;
    filter?: any;
  }): Observable<StrictHttpResponse<Array<ClientWithRelations>>> {

    const rb = new RequestBuilder(this.rootUrl, TourControllerService.TourControllerFindClientsPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
      rb.query('filter', params.filter, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<ClientWithRelations>>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `findClients$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  findClients(params: {
    id: string;
    filter?: any;
  }): Observable<Array<ClientWithRelations>> {

    return this.findClients$Response(params).pipe(
      map((r: StrictHttpResponse<Array<ClientWithRelations>>) => r.body as Array<ClientWithRelations>)
    );
  }

  /**
   * Path part for operation tourControllerCreateClient
   */
  static readonly TourControllerCreateClientPath = '/tours/{id}/client';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createClient()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createClient$Response(params: {
    id: string;
    body?: Client
  }): Observable<StrictHttpResponse<Client>> {

    const rb = new RequestBuilder(this.rootUrl, TourControllerService.TourControllerCreateClientPath, 'post');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Client>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `createClient$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createClient(params: {
    id: string;
    body?: Client
  }): Observable<Client> {

    return this.createClient$Response(params).pipe(
      map((r: StrictHttpResponse<Client>) => r.body as Client)
    );
  }

  /**
   * Path part for operation tourControllerDeleteClient
   */
  static readonly TourControllerDeleteClientPath = '/tours/{id}/client';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteClient()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteClient$Response(params: {
    id: string;
    where?: any;
  }): Observable<StrictHttpResponse<Count>> {

    const rb = new RequestBuilder(this.rootUrl, TourControllerService.TourControllerDeleteClientPath, 'delete');
    if (params) {
      rb.path('id', params.id, {});
      rb.query('where', params.where, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Count>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `deleteClient$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteClient(params: {
    id: string;
    where?: any;
  }): Observable<Count> {

    return this.deleteClient$Response(params).pipe(
      map((r: StrictHttpResponse<Count>) => r.body as Count)
    );
  }

  /**
   * Path part for operation tourControllerPatchClient
   */
  static readonly TourControllerPatchClientPath = '/tours/{id}/client';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `patchClient()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  patchClient$Response(params: {
    id: string;
    where?: any;
    body?: ClientPartial
  }): Observable<StrictHttpResponse<Count>> {

    const rb = new RequestBuilder(this.rootUrl, TourControllerService.TourControllerPatchClientPath, 'patch');
    if (params) {
      rb.path('id', params.id, {});
      rb.query('where', params.where, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Count>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `patchClient$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  patchClient(params: {
    id: string;
    where?: any;
    body?: ClientPartial
  }): Observable<Count> {

    return this.patchClient$Response(params).pipe(
      map((r: StrictHttpResponse<Count>) => r.body as Count)
    );
  }

  /**
   * Path part for operation tourControllerFindDailyProgramItems
   */
  static readonly TourControllerFindDailyProgramItemsPath = '/tours/{id}/daily-program-item';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `findDailyProgramItems()` instead.
   *
   * This method doesn't expect any request body.
   */
  findDailyProgramItems$Response(params: {
    id: string;
    filter?: any;
  }): Observable<StrictHttpResponse<Array<DailyProgramItemWithRelations>>> {

    const rb = new RequestBuilder(this.rootUrl, TourControllerService.TourControllerFindDailyProgramItemsPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
      rb.query('filter', params.filter, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<DailyProgramItemWithRelations>>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `findDailyProgramItems$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  findDailyProgramItems(params: {
    id: string;
    filter?: any;
  }): Observable<Array<DailyProgramItemWithRelations>> {

    return this.findDailyProgramItems$Response(params).pipe(
      map((r: StrictHttpResponse<Array<DailyProgramItemWithRelations>>) => r.body as Array<DailyProgramItemWithRelations>)
    );
  }

  /**
   * Path part for operation tourControllerCreateDailyProgramItem
   */
  static readonly TourControllerCreateDailyProgramItemPath = '/tours/{id}/daily-program-item';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createDailyProgramItem()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createDailyProgramItem$Response(params: {
    id: string;
    body?: DailyProgramItem
  }): Observable<StrictHttpResponse<DailyProgramItem>> {

    const rb = new RequestBuilder(this.rootUrl, TourControllerService.TourControllerCreateDailyProgramItemPath, 'post');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<DailyProgramItem>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `createDailyProgramItem$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createDailyProgramItem(params: {
    id: string;
    body?: DailyProgramItem
  }): Observable<DailyProgramItem> {

    return this.createDailyProgramItem$Response(params).pipe(
      map((r: StrictHttpResponse<DailyProgramItem>) => r.body as DailyProgramItem)
    );
  }

  /**
   * Path part for operation tourControllerDeleteDailyProgramItem
   */
  static readonly TourControllerDeleteDailyProgramItemPath = '/tours/{id}/daily-program-item';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteDailyProgramItem()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteDailyProgramItem$Response(params: {
    id: string;
    where?: any;
  }): Observable<StrictHttpResponse<Count>> {

    const rb = new RequestBuilder(this.rootUrl, TourControllerService.TourControllerDeleteDailyProgramItemPath, 'delete');
    if (params) {
      rb.path('id', params.id, {});
      rb.query('where', params.where, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Count>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `deleteDailyProgramItem$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteDailyProgramItem(params: {
    id: string;
    where?: any;
  }): Observable<Count> {

    return this.deleteDailyProgramItem$Response(params).pipe(
      map((r: StrictHttpResponse<Count>) => r.body as Count)
    );
  }

  /**
   * Path part for operation tourControllerPatchDailyProgramItem
   */
  static readonly TourControllerPatchDailyProgramItemPath = '/tours/{id}/daily-program-item';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `patchDailyProgramItem()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  patchDailyProgramItem$Response(params: {
    id: string;
    where?: any;
    body?: DailyProgramItemPartial
  }): Observable<StrictHttpResponse<Count>> {

    const rb = new RequestBuilder(this.rootUrl, TourControllerService.TourControllerPatchDailyProgramItemPath, 'patch');
    if (params) {
      rb.path('id', params.id, {});
      rb.query('where', params.where, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Count>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `patchDailyProgramItem$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  patchDailyProgramItem(params: {
    id: string;
    where?: any;
    body?: DailyProgramItemPartial
  }): Observable<Count> {

    return this.patchDailyProgramItem$Response(params).pipe(
      map((r: StrictHttpResponse<Count>) => r.body as Count)
    );
  }

  /**
   * Path part for operation tourControllerFindById
   */
  static readonly TourControllerFindByIdPath = '/tours/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `findById()` instead.
   *
   * This method doesn't expect any request body.
   */
  findById$Response(params: {
    id: string;
    filter?: any;
  }): Observable<StrictHttpResponse<TourWithRelations>> {

    const rb = new RequestBuilder(this.rootUrl, TourControllerService.TourControllerFindByIdPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
      rb.query('filter', params.filter, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<TourWithRelations>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `findById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  findById(params: {
    id: string;
    filter?: any;
  }): Observable<TourWithRelations> {

    return this.findById$Response(params).pipe(
      map((r: StrictHttpResponse<TourWithRelations>) => r.body as TourWithRelations)
    );
  }

  /**
   * Path part for operation tourControllerReplaceById
   */
  static readonly TourControllerReplaceByIdPath = '/tours/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `replaceById()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  replaceById$Response(params: {
    id: string;
    body?: Tour
  }): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, TourControllerService.TourControllerReplaceByIdPath, 'put');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `replaceById$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  replaceById(params: {
    id: string;
    body?: Tour
  }): Observable<void> {

    return this.replaceById$Response(params).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

  /**
   * Path part for operation tourControllerDeleteById
   */
  static readonly TourControllerDeleteByIdPath = '/tours/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteById()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteById$Response(params: {
    id: string;
  }): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, TourControllerService.TourControllerDeleteByIdPath, 'delete');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `deleteById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteById(params: {
    id: string;
  }): Observable<void> {

    return this.deleteById$Response(params).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

  /**
   * Path part for operation tourControllerUpdateById
   */
  static readonly TourControllerUpdateByIdPath = '/tours/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateById()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateById$Response(params: {
    id: string;
    body?: TourPartial
  }): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, TourControllerService.TourControllerUpdateByIdPath, 'patch');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `updateById$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateById(params: {
    id: string;
    body?: TourPartial
  }): Observable<void> {

    return this.updateById$Response(params).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

  /**
   * Path part for operation tourControllerFind
   */
  static readonly TourControllerFindPath = '/tours';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `find()` instead.
   *
   * This method doesn't expect any request body.
   */
  find$Response(params?: {
    filter?: any;
  }): Observable<StrictHttpResponse<Array<TourWithRelations>>> {

    const rb = new RequestBuilder(this.rootUrl, TourControllerService.TourControllerFindPath, 'get');
    if (params) {
      rb.query('filter', params.filter, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<TourWithRelations>>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `find$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  find(params?: {
    filter?: any;
  }): Observable<Array<TourWithRelations>> {

    return this.find$Response(params).pipe(
      map((r: StrictHttpResponse<Array<TourWithRelations>>) => r.body as Array<TourWithRelations>)
    );
  }

  /**
   * Path part for operation tourControllerCreate
   */
  static readonly TourControllerCreatePath = '/tours';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `create()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  create$Response(params?: {
    body?: NewTour
  }): Observable<StrictHttpResponse<Tour>> {

    const rb = new RequestBuilder(this.rootUrl, TourControllerService.TourControllerCreatePath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Tour>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `create$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  create(params?: {
    body?: NewTour
  }): Observable<Tour> {

    return this.create$Response(params).pipe(
      map((r: StrictHttpResponse<Tour>) => r.body as Tour)
    );
  }

  /**
   * Path part for operation tourControllerUpdateAll
   */
  static readonly TourControllerUpdateAllPath = '/tours';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateAll()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateAll$Response(params?: {
    where?: any;
    body?: TourPartial
  }): Observable<StrictHttpResponse<Count>> {

    const rb = new RequestBuilder(this.rootUrl, TourControllerService.TourControllerUpdateAllPath, 'patch');
    if (params) {
      rb.query('where', params.where, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Count>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `updateAll$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  // updateAll(params?: {
  //   where?: any;
  //   body?: TourPartial
  // }): Observable<Count> {

  //   return this.updateAll$Response(params).pipe(
  //     map((r: StrictHttpResponse<Count>) => r.body as Count)
  //   );
  // }

}
